<template>
  <div class="coupon_page">
    <navbar title="優惠卷"></navbar>
    <div class="coupon_container">
      <div class="row_center_center coupon_banner">

        <img src="@/assets/coupon_img.png" />
        <div class="column_start_center" style="flex-grow: 1;">
          <text v-if="usageType === 'claim'" class="coupon_type">可領取</text>
          <text v-else class="coupon_type">未使用</text>
          <text class="title">{{ couponInfo.title }}</text>
        </div>
      </div>
      <div class="column_start_start coupon_date">
        <text class="title">說明</text>
        <text class="coupon_description">{{ couponInfo.description }}</text>
        <text class="title">
          使用期限
        </text>
        <text class="coupon_description">{{ couponInfo.usage_period_begin }} ~ {{ couponInfo.usage_period_end
          }}</text>
        <text class="title">
          活動期間
        </text>
        <text class="coupon_description">
          {{ couponInfo.publish_begin }} ~ {{ couponInfo.publish_end }}
        </text>
      </div>
    </div>
    <input type="button" value="領取" class="usage_button" v-if="usageType === 'claim'" @click="claim" />
    <input type="button" value="使用" class="usage_button" style="background-color: #FD5001; color: #fff;"
      @click="showPopup" v-if="usageType === 'use'" />

    <QRCodePopup ref="QRCode" />

  </div>
</template>
<script>
import QRCodePopup from "@/components/QRCodePopup.vue";
import navbar from "@/components/general/navbar.vue";
export default {
  components: {
    QRCodePopup,
    navbar
  },
  computed: {
    usageType() {
      const params = this.$route.params;
      return params.method;
    },
    couponId() {
      const params = this.$route.params;
      return params.id;
    },
    storeCouponInfo() {
      return this.$store.state.coupon.storeCouponInfo
    },
    memberCouponInfo() {
      return this.$store.state.coupon.memberCouponInfo
    },
    couponInfo() {
      return this.usageType === 'use' ? this.memberCouponInfo : this.storeCouponInfo
    }
  },
  data() {
    return {
      showQRCode: false,
    };
  },
  mounted() {
  },
  methods: {
    showPopup() {
      this.$refs.QRCode.show = true
    },
    claim() {
      console.log("領取優惠卷 id", this.couponId);
      // const selectedCoupon = this.couponData.claimable.find(
      //   (item) => item.id === this.couponId
      // );
      // this.couponData.claimable = this.couponData.claimable.filter(
      //   (item) => item.id !== this.couponId
      // );
      // this.couponData.unused.push(selectedCoupon);
      // this.$router.go(-1);
    }
  },
};
</script>
<style lang="scss" scoped>
.coupon_container {
  width: 97vw;
  padding: 0px 1.5vw 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.coupon_banner {
  width: 88vw;
  padding: 0 5vw;
  height: 152px;
  background-image: url('@/assets/coupon_bg.png');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  img {
    width: 120px;
    height: 120px;
    border-radius: 6px;
    margin-right: 15px;
  }

  .coupon_type {
    color: #FD5001;
    border: 3px solid #FD5001;
    padding: 3px 10px;
    font-weight: 500;
    margin-bottom: 15px;
  }
}

.coupon_date {
  width: 90vw;
  overflow-x: hidden;
  padding: 10px 5vw;

  .title {
    font-size: 18px;
    margin-bottom: 10px;
  }


  .coupon_description {
    font-size: 18px;
    color: #666666;
    margin-bottom: 20px;
    letter-spacing: 1px;
  }
}

.usage_button {
  width: 84vw;
  height: 45px;
  border: none;
  background-color: #FBCB02;
  color: #000;
  font-weight: 600;
  font-family: PingFang SC;
  font-size: 15px;
  margin: 15px auto;
  border-radius: 6px;
}
</style>
